import {
  Table,
  TableBody,
  TableHead,
  TableHeader,
  TableRow,
  TableCell,
} from "V2.0/common/table";
import { Badge } from "V2.0/common/badge";
import { DocumentIcon, InformationCircleIcon, PlusIcon } from "@heroicons/react/24/outline";
// OLD: only useMemo was needed before the toolbar/create-dialog port. Replaced by
// useState (for the create-dialog open state) below, matching Frontend's version.
// import { useMemo } from "react";
import { useState } from "react";
import TabsWithBadge from "V2.0/common/tabsWithBadge";
import { Tooltip } from "antd";
import { Button } from "V2.0/common/button";
import TemplateStatusBadge from "./TemplateStatusBadge";
// NEW: brace-free create-template experience (gallery of starters + editor), ported
// from Frontend alongside the toolbar below.
import { CreateTemplateExperience } from "./create/CreateTemplateExperience";

export function WhatsappTemplates(props) {
  const { templates, tabs, setActiveTab, onRefreshStatus, projectId } = props;
  const [isCreateDialogOpen, setIsCreateDialogOpen] = useState(false);

  // OLD: table was memoized on `templates` and rendered the raw status/category Badge.
  // Replaced below (no memo; TemplateStatusBadge + rejected-reason tooltip) to match
  // Frontend's version, which ships the Create Template / Refresh Status toolbar.
  // const WhatsappTemplate = useMemo(() => {
  //   if (!Boolean(templates.data.length)) {
  //     return (
  //       <div className="border rounded-lg p-8 flex flex-col items-center justify-center h-80 gap-y-4">
  //         <p className="text-sm">No templates available</p>
  //       </div>
  //     );
  //   }
  //
  //   return (
  //     <Table>
  //       <TableHead>
  //         <TableHeader>Name</TableHeader>
  //         <TableHeader>Language</TableHeader>
  //         <TableHeader>Status</TableHeader>
  //         <TableHeader>Category</TableHeader>
  //       </TableHead>
  //       <TableBody>
  //         {templates.data.map((whatsappTemplate, idx) => {
  //           const { name, language, status, category } = whatsappTemplate;
  //
  //           return (
  //             <TableRow key={idx}>
  //               <TableCell>
  //                 <div className="flex gap-x-2 items-center">
  //                   <DocumentIcon className="size-4" />
  //                   <p className="font-semibold text-sm">{name}</p>
  //                 </div>
  //               </TableCell>
  //               <TableCell>
  //                 <Badge>{language}</Badge>
  //               </TableCell>
  //               <TableCell>
  //                 <Badge>{status}</Badge>
  //               </TableCell>
  //               <TableCell>
  //                 <Badge>{category}</Badge>
  //               </TableCell>
  //             </TableRow>
  //           );
  //         })}
  //       </TableBody>
  //     </Table>
  //   );
  // }, [templates]);

  const WhatsappTemplate = !Boolean(templates.data.length) ? (
    <div className="border rounded-lg p-8 flex flex-col items-center justify-center h-80 gap-y-4">
      <p className="text-sm">No templates available</p>
    </div>
  ) : (
    <Table>
      <TableHead>
        <TableHeader>Name</TableHeader>
        <TableHeader>Language</TableHeader>
        <TableHeader>Status</TableHeader>
        <TableHeader>Category</TableHeader>
      </TableHead>
      <TableBody>
        {templates.data.map((whatsappTemplate, idx) => {
          const { name, language, status, category, rejected_reason } = whatsappTemplate;

          return (
            <TableRow key={idx}>
              <TableCell>
                <div className="flex gap-x-2 items-center">
                  <DocumentIcon className="size-4" />
                  <p className="font-semibold text-sm">{name}</p>
                </div>
              </TableCell>
              <TableCell>
                <Badge>{language}</Badge>
              </TableCell>
              <TableCell>
                <div className="flex gap-x-2 items-center">
                  <TemplateStatusBadge status={status} />
                  {status === 'REJECTED' && rejected_reason && (
                    <Tooltip title={rejected_reason}>
                      <InformationCircleIcon className="size-4 text-red-500 cursor-help" />
                    </Tooltip>
                  )}
                </div>
              </TableCell>
              <TableCell>
                <Badge>{category}</Badge>
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );

  return (
    <>
      <div className="border rounded-lg flex flex-col h-full flex-1">
        <div className="flex-shrink-0 flex justify-between items-center px-4 bg-gray-50 rounded-t-lg w-full">
          <TabsWithBadge
            className="flex-shrink-0"
            tabs={tabs}
            onTabChange={(e, { tab, index }) => setActiveTab(tab.name)}
          />
          <div className="flex gap-2">
            <Button
              onClick={() => setIsCreateDialogOpen(true)}
              color="white"
            >
              <PlusIcon className="size-4" />
              Create Template
            </Button>
            <Button
              onClick={onRefreshStatus}
              disabled={templates.loading}
              color="white"
            >
              {templates.loading ? 'Refreshing...' : 'Refresh Status'}
            </Button>
          </div>
        </div>
        <div className="flex-1 min-h-0 p-4 overflow-y-scroll">
          {WhatsappTemplate}
        </div>
      </div>

      <CreateTemplateExperience
        projectId={projectId}
        isOpen={isCreateDialogOpen}
        onClose={() => setIsCreateDialogOpen(false)}
        onSuccess={() => {
          setIsCreateDialogOpen(false);
          onRefreshStatus?.();
        }}
      />
    </>
  );
}
